module.exports = __webpack_public_path__ + "img/logo-indorock.871b7d35.png";